import React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import { Helmet } from 'react-helmet';

import banner from '../images/banner.jpg';

const HomeContainer = styled.div`
  width: 100%;
`;

const BannerSection = styled.section`
  width: 100%;
  background-color: #0099ff;
  padding: 0.5rem 0;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  margin-bottom: 0.5rem;
`;

const BannerImage = styled.div`
  width: 80%;
  height: 400px;
  background-image: url(${banner});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const WelcomeSection = styled.section`
  padding: 0 5rem 2rem;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 0 2rem 1rem;
  }
`;

const WelcomeTitle = styled.h2`
  font-size: 2.4rem;
  color: #0099ff;
  margin: 0 0 1rem;
`;

const WelcomeText = styled.p`
  color: #333;
  line-height: 1.6;
  font-size: 1rem;
`;

export default function HomePage() {
  return (
    <Layout>
      <Helmet>
        <title>Wisdom - Home Appliances & Electronics</title>
        <meta name="description" content="Wisdom home appliances" />
      </Helmet>

      <HomeContainer>
        <BannerSection>
          <BannerImage />
        </BannerSection>

        <WelcomeSection>
          <WelcomeTitle>WELCOME</WelcomeTitle>
          <WelcomeText>
            To OEM and ODM consumer electronics, Home appliances, Small Home appliances, since 2006, we supply high quality and good service to our cleints. Since 2019, we have started to sell our Wisdom brands products in Asia market by lazada. Now we have more than 500 SKU available for OEM and wholesale.
          </WelcomeText>
        </WelcomeSection>
      </HomeContainer>
    </Layout>
  );
}